import React from 'react'
import PropTypes from 'prop-types'
import { GridColumn, GridRow } from 'semantic-ui-react'
import RegisteredFormField from '../../common/RegisteredFormField'

const HealthQuestionAdditionalInformationRow = ({ path, index, removeRow }) => {
  return <GridRow key={index}>
    <GridColumn width={16}>
      <h5>{`Additional Information (${index + 1})`}&nbsp;{removeRow && removeRow}</h5>
    </GridColumn>
    <GridColumn width={5}>
      <RegisteredFormField
        id={`applicantName-${index}`}
        label='Applicant Name'
        path={`${path}[${index}].applicantName`}
      />
    </GridColumn>
    <GridColumn width={5}>
      <RegisteredFormField
        id={`occurrenceDate-${index}`}
        label='Date of Occurrence'
        path={`${path}[${index}].occurrenceDate`}
      />
    </GridColumn>
    <GridColumn width={5}>
      <RegisteredFormField
        id={`recoveryDate-${index}`}
        label='Date of Recovery'
        path={`${path}[${index}].recoveryDate`}
      />
    </GridColumn>
    <GridColumn width={8}>
      <RegisteredFormField
        id={`recoveryDegree-${index}`}
        label='Current Status/Degree of Recovery'
        path={`${path}[${index}].recoveryDegree`}
      />
    </GridColumn>
    <GridColumn width={8}>
      <RegisteredFormField
        id={`detail-${index}`}
        label='Diagnosis/Condition/Treatment/Medication/Exam Results'
        path={`${path}[${index}].detail`}
      />
    </GridColumn>
    <GridColumn width={16}>
      <RegisteredFormField
        id={`physicianInformation-${index}`}
        label="Attending Physician's Name, Address & Phone"
        path={`${path}[${index}].physicianInformation`}
      />
    </GridColumn>
  </GridRow>
}

HealthQuestionAdditionalInformationRow.propTypes = {
  /** Redux store object root path */
  path: PropTypes.string.isRequired,
  /** The array index for this form object */
  index: PropTypes.number.isRequired,
  /** A button to render, that when clicked, removes the object at specified index */
  removeRow: PropTypes.object
}

export default HealthQuestionAdditionalInformationRow